module.exports = __webpack_public_path__ + "img/avatar-pasaz-grunwaldzki.44cc62f9.svg";